const setArrayValues = item => {
  return item.values[0]?.id ? item.values.map(val => val.id) : item.values;
};

const generateValues = item => {
  if (item.attribute_key === 'content') {
    const values = item.values || '';
    return values.split(',');
  }
  if (Array.isArray(item.values)) {
    return setArrayValues(item);
  }
  if (typeof item.values === 'object') {
    return [item.values.id];
  }
  if (!item.values) {
    return [];
  }
  return [item.values];
};

// Conditions flagged "only on change" (see ATTRIBUTE_CHANGE_SUPPORTED_KEYS in
// AutomationRuleForm.vue) are edited as a regular equal_to condition in the UI —
// they're rewritten here into the attribute_changed shape the backend understands
// (AutomationRules::ConditionsFilterService), so the rule only fires when the
// attribute actually transitions into the selected value(s) in that event, instead of
// re-matching on every unrelated conversation_updated dispatch while the value stays set.
const buildConditionPayload = item => {
  const { onlyOnChange, ...condition } = item;
  const values = generateValues(item);

  if (onlyOnChange && item.filter_operator === 'equal_to') {
    return { ...condition, filter_operator: 'attribute_changed', values: { from: [], to: values } };
  }

  return { ...condition, values };
};

const generatePayload = data => {
  // Make a copy of data to avoid vue data reactivity issues
  const filters = JSON.parse(JSON.stringify(data));
  let payload = filters.map(buildConditionPayload);

  // For every query added, the query_operator is set default to and so the
  // last query will have an extra query_operator, this would break the api.
  // Setting this to null for all query payload
  payload[payload.length - 1].query_operator = undefined;
  return { payload };
};

export default generatePayload;
